import { useContext } from 'react';
import { Stack, Paper } from '@mui/material';

import AuthKey from './AuthKey';
import CreateDomain from './CreateDomain';
import DomainsList from './DomainsList';
import DomainControllers from '../domainControllers/DomainControllers';

import AuthContext from '../../contexts/authContext';

const Deploy = () => {
  const { planFeatures } = useContext(AuthContext);
  const { areLocalDomainsAvailable } = planFeatures;

  return (
    <Stack sx={{ position: 'relative', gap: 4 }}>
      <AuthKey />
      {areLocalDomainsAvailable ? <DomainControllers /> : null}
      <Paper>
        <CreateDomain />
        <DomainsList />
      </Paper>
    </Stack>
  );
};

export default Deploy;
